import * as ActionType from '../../constants/constant_action_types';

const INITIAL_STATE = {
  data: {}
};

export default function inventoryAdjustmentReducer( state = INITIAL_STATE, action ) {
  switch ( action.type ) {
    case ActionType.SET_INVENTORY_ADJUSTMENT: {
      let result = {
        ...state, data: { ...action.data }
      };

      if( action.settings ){
        result = { ...result, settings: action.settings };
      }

      return result;
    }

    case ActionType.CLEAR_INVENTORY_ADJUSTMENT: {
      return {
        ...INITIAL_STATE
      }
    }

    default:
      return state;
  }
}